import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { BeneficiarioZelle } from 'src/app/dashboard/interfaces/beneficiario-zelle.interface';
import { RecipientZelleService } from 'src/app/dashboard/services/recipient-zelle.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { DialogBeneficiaryZelleComponent } from '../dialog-beneficiary-zelle/dialog-beneficiary-zelle.component';

@Component({
  selector: 'app-recipient-zelle-list',
  templateUrl: './recipient-zelle-list.component.html',
  styleUrls: ['./recipient-zelle-list.component.sass']
})
export class RecipientZelleListComponent implements OnInit, OnDestroy {
  usuarioID: number | undefined;
  @Output() reloadAccountList: EventEmitter<any> = new EventEmitter();
  @Output() actualizarCuenta: EventEmitter<BeneficiarioZelle> = new EventEmitter();
  @Output() seleccion: EventEmitter<BeneficiarioZelle> = new EventEmitter();
  subscriptions: Subscription = new Subscription();
  @Input() listaCuentas: BeneficiarioZelle[] = [];

  @Input() seleccionable: boolean = false;
  cuentaSeleccionada: BeneficiarioZelle | undefined;

  expandedCardId: string | null = null;

  displayedColumns: string[] = ['nombre', 'tipo', 'banco', 'identificador', 'numeroCuenta', 'acciones'];

  constructor(
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private spinner: SpinnerService,
    private accountRecipientService: RecipientZelleService,
  ) {}

  toggleCard(id: string | undefined): void {
    if (!id) return;
    this.expandedCardId = this.expandedCardId === id ? null : id;
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  // Acciones tabla
  verCuenta(cuenta: BeneficiarioZelle): void {
    const isMobile = window.innerWidth < 768;
    this.dialog.open(DialogBeneficiaryZelleComponent, {
      data: cuenta,
      disableClose: true,
      panelClass: 'aguacate-dialog',
      maxWidth: isMobile ? '95vw' : '500px',
      minWidth: isMobile ? '90vw' : '420px',
      maxHeight: '90vh',
    });
  }

  async inactivarCuenta(cuenta: BeneficiarioZelle): Promise<void> {
    if (!cuenta || !cuenta.id) return;
    const result = await Swal.fire({
      title: '¿Está seguro de que desea desvincular esta cuenta?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      confirmButtonColor: '#1e5a3f',
    });
    if (result.isDenied || !result.isConfirmed) return;
    const spinnerRef = this.spinner.start();
    try {
      await this.accountRecipientService.inactivateAccount(cuenta.id);
      this.snackBar.open('Cuenta eliminada correctamente', 'Ok', { duration: 3000 });
      this.reloadAccountList.emit();
    } catch (error) {
    }
    this.spinner.stop(spinnerRef);
  }

  actualizar(cuenta: BeneficiarioZelle): void {
    this.actualizarCuenta.emit(cuenta);
  }

  seleccionar(cuenta: any): void {
    if (!this.seleccionable) return;
    if (this.cuentaSeleccionada && this.cuentaSeleccionada?.id !== cuenta.beneficiario_id) {
      this.cuentaSeleccionada.seleccionado = false;
    }
    cuenta['seleccionado'] = cuenta['seleccionado'] ? !cuenta['seleccionado'] : true;
    if (cuenta.seleccionado) {
      this.cuentaSeleccionada = cuenta;
      this.seleccion.emit(cuenta);
    } else {
      this.seleccion.emit(undefined);
      this.cuentaSeleccionada = undefined;
    }
  }
}
